export {
  OnboardingBannerHideWrapper as OnboardingBanner,
  OnboardingBannerProps,
} from './OnboardingBanner'
